import React, { useCallback, useMemo } from 'react';
import styled from 'styled-components';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import { getGroups, deleteGroup, getAutomationUser, enableAutomationUser } from '../../../Redux/user/action';
import { OverlayTrigger, Toast, ToastContainer } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import axiosInstance from './../../../axiosInstance';
import { GET_GROUPS_URL } from "../../../api";
import { CREATE_AUTOMATION_USER, EDIT_AUTOMATION_USER } from '../../../routeNames';
import { changeAllTitleFunction } from '../Dashboard/functions';
//import { Button } from '@mui/material';
import { Tooltip } from '@mui/material';
import Select, { components } from 'react-select';
import { getAllStaffs } from '../../../Redux/clientGroup/action';
import { HiChevronDown } from 'react-icons/hi';
import { enableOrDisableAutomation } from '../../../Redux/client/action';
import AdminMaster from '../../../Layout/admin/Master';
import DataTable from 'react-data-table-component';
import queueDatatableCustomStyles from '../../../Layout/Elements/QueueDatatableCustomStyles';
import FilterComponent from '../../common/FilterComponent';
import { Formik } from 'formik';
import { BiReset, BiSearch } from 'react-icons/bi';


const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <HiChevronDown size={20} />
            </components.DropdownIndicator>
        )
    );
};

const FilterComponents = ({ staffList, setIsFocusedStaff, handleOnMultySelectChange, filterValues }) => (
    <>
        <Select
            options={staffList}
            isMulti
            isClearable
            formatOptionLabel={({ value, label, is_logged_in }) => (
                <div className='d-flex flex-row justify-content-between align-items-center'>
                    <div>{label}</div>

                </div>
            )}
            components={{ DropdownIndicator: (props) => <DropdownIndicator {...props} state="staff" /> }}
            className="select-search-job-monitor"
            classNamePrefix="select"
            placeholder="User"
            name="staff"
            onFocus={() => setIsFocusedStaff(true)}
            onBlur={() => setIsFocusedStaff(false)}
            onChange={(e) => handleOnMultySelectChange(e, 'staff')}
            value={staffList?.filter(opt => filterValues?.staff && Array.isArray(filterValues.staff) ? filterValues.staff.includes(opt.value) : false)}
            styles={{
                container: (base) => ({
                    ...base,

                    minWidth: "250px",
                }),

                control: (base, state) => ({
                    ...base,
                    minHeight: "38px",
                    backgroundColor: "hsl(204deg 33.33% 97.06%)",
                    border: "none",
                    boxShadow: "none",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                }),

                valueContainer: (base) => ({
                    ...base,
                    padding: "0 8px",
                }),

                indicatorSeparator: () => ({
                    display: "none",
                }),
            }}


        />
    </>
);



const TextField = styled.input`
    height: 38px;
    width: 250px;
    border-radius: 10px;
    background-color: hsl(204deg 33.33% 97.06%);
    border: none;
    padding: 0 10px;
    &:focus {
        outline: none;
        box-shadow: none;
    }
`;

const Automation = () => {
    const [reRenderDataTable, setRerenderDataTable] = useState(false)
    const [isSwal, setIsSwal] = useState({
        show: false,
        id: ''
    })
    const [toaster, setToaster] = useState(false)
    const [toasterMessage, setToasterMessage] = useState('')
    const [state, setState] = useState({
        error: false,
        error_message: "",
        showToast: false,
    });

    const [loading, setLoading] = useState(false);
    const [groupExists, setGroupExists] = useState(true);
    const [totalRows, setTotalRows] = useState(100);
    const [limit, setLimit] = useState(100);
    const [data, setData] = useState({ results: [] })
    const [enable, setEnable] = useState({ results: [] })
    const [colorRow, setColorRow] = useState({});
    const [filterText, setFilterText] = React.useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);
    const [pageno, setPageNo] = useState(1);
    const [staffList, setStaffList] = useState([]);
    const [isFocusedStaff, setIsFocusedStaff] = useState(false);
    const [filterValues, setFilterValues] = useState({ staff: "", status: "" });
    const [searchedData, setSearchedData] = useState({ staff: "", status: "" });





    const columns = useMemo(
        () => [

            {
                id: 'id',
                name: 'S NO',
                selector: (row, index) => pageno == 1 ? index + 1 : (pageno - 1) * limit + index + 1,
                // sortable: true,
                wrap: true,
                width: "70px",
                grow: 0,

            },

            {
                id: 'groupName',
                name: 'Group Name',
                selector: row => row.group,
                cell: (row) => <div>
                    {row?.group &&


                        <div className='overflow-hidden d-flex flex-row  flex-wrap text-truncate' onClick={() => handleRowClick(row)} style={{ width: "260px" }}>
                            <Tooltip disableInteractive title={row?.group} placement='top' arrow>
                                <span className='text-truncate'> {row?.group}</span>
                            </Tooltip>
                        </div>
                    }

                </div>,
                sortable: true,
                left: true,
                wrap: true,
                cursor: "pointer",
                width: "150px",
                //grow: 0.3,


            },

            {
                id: 'User',
                name: 'User',
                selector: row => row.users,
                // sortable: true,
                left: true,
                fixed: true,
                wrap: true,
                cell: (row) => (

                    <div className='d-flex flex-row justify-content-start flex-wrap'>
                        {row && row?.users && (Array.isArray(row.users) ? row.users : [row.users]).map((role, index) => (

                            <span key={index} className="badge badge-light-primary fs-7 fw-bold" onClick={() => handleRowClick(row)}>
                                {role}
                            </span>
                        ))}
                    </div>
                )
            },

            {
                id: 'edit',
                name: 'Actions',
                cell: (row) =>
                    <div className="d-flex justify-content-end align-items-center flex-shrink-0" style={{ gap: '14px' }}>
                        <Tooltip disableInteractive title='Assign User' placement='top' arrow>
                            <Link
                                to="#"
                                onClick={() => changeAllTitleFunction('Assign User', EDIT_AUTOMATION_USER + "/" + row.id)}
                                className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                                style={{ width: '30px', height: '25px', display: 'flex', }}
                            >
                                <span className="svg-icon svg-icon-4">

                                    <i className='bi bi-person-plus-fill'></i>

                                </span>
                            </Link>
                        </Tooltip>

                        <Tooltip disableInteractive title="Status" placement='top' arrow>
                            <div
                                className="form-check form-switch form-switch-toggle d-flex align-items-center mb-0"
                                style={{ height: '30px', paddingLeft: '2.5em' }}
                                onClick={() => handleEnableOrDisableAutomationUser(row.id)}
                            >
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={row.is_active}
                                    role="switch"
                                    id="flexSwitchCheckDefault"
                                    readOnly
                                    style={{ width: '34px', height: '17px', cursor: 'pointer' }}
                                />
                            </div>
                        </Tooltip>
                    </div>,

                right: true,
                button: false,
            },

        ],
        [pageno],
    );




    const fetchAutomationUser = async (page, limit, searchInput = null, filtersInput = null) => {
        setLoading(true);
        const currentFilters = filtersInput !== null ? filtersInput : searchedData;
        const search = searchInput !== null ? searchInput : filterText;

        const staffIds = Array.isArray(currentFilters?.staff) ? currentFilters.staff.join(',') : currentFilters?.staff || "";

        getAutomationUser({
            page,
            limit,
            search: search || "",
            user: staffIds,
            is_active: currentFilters?.status || ""
        })((response) => {
            if(response?.status){

                const count = response?.count ?? response?.data?.count ?? 0;
                
                setData(response?.data);
                setTotalRows(count);
                setLimit(limit);
                setPageNo(page);
                setLoading(false);
            }
        });
    };



    const handleEnableOrDisableAutomationUser = async (user_id) => {
        enableAutomationUser(user_id)((response) => {
            setEnable(response);
            if (response?.status) {
                setData(prevData => ({
                    ...prevData,
                    results: prevData.results.map(item =>
                        item.id === user_id ? { ...item, is_active: !item.is_active } : item
                    )
                }));
                setToasterMessage('');
                setToaster('success');
                setTimeout(() => {
                    setToaster('');
                }, 2000);
            } else {
                fetchAutomationUser(pageno, limit, filterText);
                const errors = response?.response?.data?.errors;
                const errMsg = errors
                    ? (typeof errors === 'string' ? errors : Object.values(errors)[0])
                    : 'Failed';
                setToasterMessage(errMsg);
                setToaster('error');
                setTimeout(() => {
                    setToaster('');
                    setToasterMessage('');
                }, 2000);
            }
        });

    };


    const handlePageChange = page => {
        setPageNo(page);
        fetchAutomationUser(page, limit, filterText);
    };

    const handlePerRowsChange = async (newPerPage, page) => {

        setLimit(newPerPage);
        setPageNo(1)

        fetchAutomationUser(1, newPerPage, filterText)
        handleResetDataTable()
    };



    useEffect(() => {
        fetchAutomationUser(1, limit, filterText);
        getAllStaffs()((response) => {
            setStaffList(response?.data?.results || response?.data || [])
        });
    }, []);

    const handleSearchTrigger = () => {
        setSearchedData(filterValues);
        fetchAutomationUser(1, limit, filterText, filterValues);
    };

    const handleResetFilters = () => {
        const resetValues = { staff: null, status: null };
        setFilterValues(resetValues);
        setSearchedData(resetValues);
        setFilterText('');
        fetchAutomationUser(1, limit, '', resetValues);
        handleResetDataTable();
    };

    // Handler for multi-select change
    const handleOnMultySelectChange = async (selected, name) => {
        if (name === "staff") {
            const values = selected ? selected.map(item => item.value) : null;
            setFilterValues({ ...filterValues, [name]: values });
        } else {
            setFilterValues({ ...filterValues, [name]: selected ? selected.value : null });
        }
    }
    // // console.log(data.data);
    const onClickDeleteGroup = (group_id) => {
        // console.log(group_id);
        // // console.log(group);
        // let formData = new FormData();    //formdata object

        // formData.append('group', group_id);

        deleteGroup(group_id)((response) => {
            // console.log(response);
            // setData(response);
            if (response?.status) {


                fetchAutomationUser(pageno, limit, filterText)


                setToaster('success')
                setTimeout(() => {
                    setToaster('')

                }, 2000);

            } else {
                setToaster('error')
                setTimeout(() => {
                    setToaster('')

                }, 2000);
            }
        });
    }
    // Removed redundant searchAutomationUser handler
    // const searchAutomationUser = (e) => {
    //     const value = e.target.value || '';

    //     setFilterText(value);

    //     fetchAutomationUser(1, limit, value);
    // };

    const subHeaderComponentMemo = React.useMemo(() => {


        // return (
        //     <FilterComponent onFilter={(e) => searchGroups(e)} onClear={handleClear} filterText={filterText} />
        // );
    }, [filterText, resetPaginationToggle]);

    const handleClear = () => {
        if (filterText) {
            setFilterText('');
            fetchAutomationUser(1, limit, '');
        }
    };

    const checkUserPermission = (check) => {
        var permissions = localStorage.getItem('permissions')
        if (permissions) {
            permissions = JSON.parse(permissions)
            var data = permissions.find((element) => {
                return element == check;
            })
            // // console.log(data)
            if (data && data != undefined) {
                return true;
            }
            else {

                return false;
            }
        } else {
            return false
        }
    }
    var i = 0;
    const conditionalRowStyles = [

        {
            when: row => { i = i + 1; return i % 2 == 0 || colorRow.pk == row.pk ? true : false },
            style: (row, index) => ({
                backgroundColor: colorRow?.pk == row.pk ? '#dbf4f5' : '#f2f2f2',
            }),
        },

    ];

    const handleRowClick = (row) => {
        setColorRow(row);
        // // console.log(row);
    };

    const handleRowCheckClick = (row) => {
        data?.results.map((item, index) => {
            if (row?.id == item.id) {
                setColorRow(row)
            }
        })
        // // console.log(row);
    };
    const status_list =
        [{ value: "true", label: "Active" },
        { value: "false", label: "In Active" }]


    const handleResetDataTable = () => {
        setRerenderDataTable(true)
        setTimeout(() => {
            setRerenderDataTable(false)
        }, 200);
    }
    return (
        <React.Fragment>
            <AdminMaster ToastMessage={toaster} message={toasterMessage} />
            <main id="main" className="main">

                <div className="pagetitle tab-fixed-header">
                    <h1 id='page-title'>Automation User</h1>
                </div>

                <section className="section mt-5" >
                    <div className="row align-items-top py-2 gap-2 gap-md-5">
                        <div className="col-lg-12">
                            <div className="card mb-5 mb-xl-8">


                                <div className="card-header border-0">
                                    <div className="d-flex align-items-center gap-2 ms-3">
                                        <div className='d-flex align-items-center gap-2'>



                                            {/* <div className='jobmonitor-select'>
                                                <TextField
                                                    id="search"
                                                    className="form-control form-control-solid fileManagePadding b-r-10"
                                                    name='search'
                                                    type="search"
                                                    style={{ width: "100%", fontSize: "17px" }}
                                                    placeholder="Search Group Name"
                                                    aria-label="Search Input"
                                                    value={filterText}
                                                    onChange={(e) => setFilterText(e.target.value)}
                                                />
                                            </div> */}

                                            <FilterComponents
                                                staffList={staffList}
                                                setIsFocusedStaff={setIsFocusedStaff}
                                                handleOnMultySelectChange={handleOnMultySelectChange}
                                                filterValues={filterValues}
                                            />
                                            {/* <Select
                                                        options={status_list}
                                                        className="select-search-client"
                                                        classNamePrefix="select"
                                                        placeholder="Select Status"
                                                        menuPlacement="auto"
                                                        maxMenuHeight={300}
                                                        isClearable
                                                        name="status"
                                                        value={status_list.find(opt => opt.value === filterValues.status) || null}
                                                        onChange={(e) => { handleOnMultySelectChange(e, "status") }}
                                                        styles={{
                                                            control: styles => ({ ...styles, backgroundColor: "hsl(204deg 33.33% 97.06%)", borderStyle: "none", boxShadow: "none", borderRadius: "10px", minWidth: "160px" }), placeholder: styles => ({
                                                                ...styles,
                                                            }), indicatorSeparator: styles => ({ ...styles, width: "0px", minHeight: "20px" }), container: styles => ({ ...styles, borderRadius: "9px" })
                                                        }}
                                                    /> */}

                                            <Tooltip disableInteractive title="Search" placement='top' arrow>
                                                <Button className="btn btn-light btn-active-primary" onClick={handleSearchTrigger}>
                                                    <BiSearch size={18} />
                                                </Button>
                                            </Tooltip>
                                            {/* 
                                                    <Tooltip disableInteractive title="Reset" placement='top' arrow>
                                                        <Button className="btn btn-light btn-active-primary" onClick={handleResetFilters}>
                                                            <BiReset size={18} />
                                                        </Button>
                                                    </Tooltip> */}
                                        </div>
                                    </div>

                                    {!groupExists && (
                                        <div className="card-toolbar gap-2 me-4" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-trigger="hover" data-bs-original-title="Click to add a user" data-kt-initialized="1">
                                            <Link to="#" onClick={() => changeAllTitleFunction('Create Automation User', CREATE_AUTOMATION_USER)} className="btn btn-light btn-active-primary">
                                                <span className="svg-icon svg-icon-3">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <rect opacity="0.5" x="11.364" y="20.364" width="16" height="2" rx="1" transform="rotate(-90 11.364 20.364)" fill="currentColor"></rect>
                                                        <rect x="4.36396" y="11.364" width="16" height="2" rx="1" fill="currentColor"></rect>
                                                    </svg>
                                                </span>
                                                Create
                                            </Link>
                                        </div>
                                    )}
                                </div>
                                <div className="card-body py-3">
                                    <div className="table-responsive">
                                        <div className='dashboardtable'>
                                            {!reRenderDataTable &&
                                                <DataTable
                                                    className="custom-datatable"
                                                    data={data?.results}
                                                    columns={columns}
                                                    progressPending={loading}
                                                    pagination
                                                    paginationServer
                                                    paginationTotalRows={totalRows}
                                                    paginationPerPage={limit}
                                                    fixedHeader={true}
                                                    paginationRowsPerPageOptions={[25, 50, 100]}
                                                    onChangeRowsPerPage={handlePerRowsChange}
                                                    onChangePage={handlePageChange}
                                                    // conditionalRowStyles={conditionalRowStyles}
                                                    onRowClicked={handleRowCheckClick}
                                                    // subHeader
                                                    // subHeaderComponent={subHeaderComponentMemo}
                                                    theme="solarized"
                                                    customStyles={queueDatatableCustomStyles}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


            </main>
        </React.Fragment>
    )
}

export default Automation; 
